import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {
  BoardingCheckListService,
  CurrentUserWatchService,
  DashboardService,
} from '../../services';
import { MenuService } from '../../services';
import { OrganisationsService } from '../../services';
import { OrganisationTypeEnum } from 'src/app/enums/organisation-types';
import { SaasService } from '../../utils/saas.service';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  public organisationType: number = 0;
  public boardingCheckList: any = {};

  private engineiusHomepageTesters = [
    // '69a8b171-74fe-43ee-8504-e8e1a564587a',
    // 'de65f5f4-b1f8-49cb-ae58-4413a1eb2f6d',
    // '23b46623-7012-416c-a2ec-1ecef5935ccf',
    // '76388841-fd74-4089-8ad3-42c41e0a8de8',
    // '914cc946-64ff-47c2-bc93-429cbf60e6af',
  ];

  public showEngineiusHomepage: boolean = false;
  public userOrg;

  public isBusy = false;

  constructor(
    private organisationsService: OrganisationsService,
    private boardingCheckListService: BoardingCheckListService,
    private router: Router,
    private menuService: MenuService,
    private userWatchService: CurrentUserWatchService,
    private dashboardService: DashboardService,
    private saasService: SaasService,
  ) {}

  async ngOnInit() {
    this.isBusy = true;

    this.organisationType = await this.organisationsService.getCurrentUserOrgTypeId();

    if (this.saasService.redirectToSaasIfSaasUser(this.organisationType)) {
      return;
    }

    this.boardingCheckListService.changeBoardingCheckList.subscribe(() => {
      this.boardingCheckListService.GetBoardingCheckList().then((result) => {
        if (result) {
          this.menuService.reloadMenu.next(result.isHide);
          this.boardingCheckList = result;
        }
      });
    });

    const currentUser = await this.userWatchService.getLoggedUserPromise;

    this.userOrg = await this.organisationsService.getOrg(currentUser.organisationId);

    this.dashboardService.getRedirect().then((redirect) => {
      if (redirect) {
        this.router.navigate([redirect]);
      }
    });

    this.isBusy = false;
  }

  onSupplierSignupTypeSet(signupTypeId: number) {
    this.userOrg.supplierSignupTypeId = signupTypeId;
  }
}
